import { render, staticRenderFns } from "./TncCategory.vue?vue&type=template&id=5455feb6&"
import script from "./TncCategory.vue?vue&type=script&lang=js&"
export * from "./TncCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports